/**
 * AI Image Generation Service
 * API client functions for image generation endpoints
 */

import { apiClient } from "@/lib/api-client"

interface GeneratedImage {
  base64: string
  mimeType: string
}

interface GenerateImagesResponse {
  images: GeneratedImage[]
  generationId: string
  remainingQuota: number
  warning?: string
}

interface GenerateImagesRequest {
  entityType: "ritual" | "community" | "growth-reminder" | "coaching"
  prompt: string
  count?: number
}

interface RecentImage {
  id: string
  generationId: string
  image: string
  indexNumber: number
  isUsed: boolean
  createdAt: string
}

export async function generateImages(
  data: GenerateImagesRequest,
  signal?: AbortSignal,
): Promise<GenerateImagesResponse> {
  const response = await apiClient.post<{
    success: boolean
    data: GenerateImagesResponse
    message: string
  }>("/api/ai-image/generate", data, { signal, timeout: 30000 })

  return response.data.data
}

export async function markImageUsed(generationId: string, imageIndex: number): Promise<void> {
  await apiClient.patch(`/api/ai-image/${generationId}/mark-used`, { imageIndex })
}

export async function getRecentImages(limit: number = 5): Promise<RecentImage[]> {
  const response = await apiClient.get<{
    success: boolean
    data: { images: RecentImage[] }
    message: string
  }>(`/api/ai-image/recent?limit=${limit}`)

  return response.data.data.images
}

export type { GeneratedImage, GenerateImagesRequest, GenerateImagesResponse, RecentImage }
